import { render, staticRenderFns } from "./StatisticPrivate.vue?vue&type=template&id=0d2cd688"
import script from "./StatisticPrivate.vue?vue&type=script&lang=js"
export * from "./StatisticPrivate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports